/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_IntroInputs */

const en_share_intro = /** @type {(inputs: Share_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone with the link sees the recipe – without your notes and rating. You can revoke it at any time.`)
};

const de_share_intro = /** @type {(inputs: Share_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer den Link hat, sieht das Rezept – ohne deine Notizen und Bewertung. Du kannst ihn jederzeit zurückziehen.`)
};

/**
* | output |
* | --- |
* | "Anyone with the link sees the recipe – without your notes and rating. You can revoke it at any time." |
*
* @param {Share_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_intro = /** @type {((inputs?: Share_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_intro(inputs)
	return en_share_intro(inputs)
});